/* This file contains the various blockedReason strings that
 ** can be returned from Python.
 */

export const LOANS_IN_DEFAULT = "User's loans are in default";
export const REQUIRES_CONSOLIDATION =
  'Plan requires consolidation for Plaid loans';
